import styled from "styled-components";
import Chip from "../Chip";
import ActionImageButton from "../DataTable/ActionImageButton";
import ListWithPagination from "../ListsWithPagination";
import { TableWithPagination } from "../TableWithPagination";

interface Props {
  data: {
    id: number;
    outlet: string;
    outlet_type: string;
    status: boolean;
  }[];
  currentPage: number;
  totalData: number;
  rowsPerPage: number;
  onEdit: (id: string) => void;
  isTableDataLoading: boolean;
  onPageChange: (page: number) => void;
}

const ManageOutletTable = ({
  data,
  onEdit,
  isTableDataLoading,
  totalData,
  currentPage,
  rowsPerPage,
  onPageChange,
}: Props) => {
  const columns = [
    {
      path: "name",
      label: "Outlet",
    },
    {
      path: "type",
      label: "Outlet Type",
    },
      {
      path: "order",
      label: "Outlet Order",
    },
    {
      key: "isActive",
      label: "Status",
      content: (outlet: { isActive: boolean }) => (
        <Chip
          label={outlet.isActive ? "Active" : "Inactive"}
          variant={outlet.isActive ? "success" : "error"}
        />
      ),
    },
    {
      label: "Action",
      key: "edit",
      content: (outlet: { _id: number | string | any ,type:string}) => (
       outlet.type !== 'Parks' && <ActionImageButton
          onClick={() => onEdit(outlet._id)}
          iconPath={require("../../assets/images/edit-icon.png")}
          label={"Edit Outlet"}
        />
      ),
    },
  ];
  return (
    <>
      <TableWrapper>
        <TableWithPagination
          onPageChange={onPageChange}
          totalData={totalData}
          currentPage={currentPage}
          rowsPerPage={rowsPerPage}
          columns={columns}
          data={data}
          isTableDataLoading={isTableDataLoading}
        />
      </TableWrapper>
      <ListWrapper>
        <ListWithPagination
          onPageChange={onPageChange}
          totalData={totalData}
          currentPage={currentPage}
          rowsPerPage={rowsPerPage}
          columns={columns}
          data={data}
          isTableDataLoading={isTableDataLoading}
          title={"Outlet Details"}
          onRowClick={undefined}
        />
      </ListWrapper>
    </>
  );
};

const ListWrapper = styled.div`
  display: none;
  @media only screen and (max-width: 768px) {
    display: block;
  }
`;
const TableWrapper = styled.div`
  display: block;
  @media only screen and (max-width: 768px) {
    display: none;
  }
`;

export default ManageOutletTable;
